export const GET_HELD_SUBMISSIONS = "GET_HELD_SUBMISSIONS";
export const HELD_SUBMISSIONS_LOADING = "HELD_SUBMISSIONS_LOADING";
export const REMOVE_HELD_SUBMISSION = "REMOVE_HELD_SUBMISSION";
